import type { CreateFieldOptions } from '@cims-online/shared'
import ApprovalCreationField from './components/ApprovalCreationField'
import LongTextCreationField from './components/LongTextCreationField'
import PayItemsCreationField from './components/PayItemsCreationField'

export type CreationFieldProps = {
  error: string | undefined
  field: CreateFieldOptions
  onBlur: () => void
}

/** Renders the control associated with one configured creation field type. */
function CreationField({ error, field, onBlur }: CreationFieldProps) {
  if (field.type === 'long_text')
    return <LongTextCreationField error={error} field={field} onBlur={onBlur} />
  else if (field.type === 'pay_items')
    return <PayItemsCreationField error={error} field={field} onBlur={onBlur} />
  else
    return <ApprovalCreationField error={error} field={field} onBlur={onBlur} />
}

export default CreationField
